"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderPayResponseDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const billing_api_payment_response_dto_1 = require("../../../billing-api-payment/types/dtos/billing-api-payment-response.dto");
const billing_api_order_response_dto_1 = require("./billing-api-order-response.dto");
class BillingApiOrderPayResponseDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "���������� ���������� � ������",
  type: () => billing_api_order_response_dto_1.BillingApiOrderResponseDto
}), __metadata("design:type", billing_api_order_response_dto_1.BillingApiOrderResponseDto)], BillingApiOrderPayResponseDto.prototype, "order", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "����� ��������� � ���������� ������ ���������� � ������",
  type: () => billing_api_payment_response_dto_1.BillingApiPaymentResponseDto
}), __metadata("design:type", billing_api_payment_response_dto_1.BillingApiPaymentResponseDto)], BillingApiOrderPayResponseDto.prototype, "payment", void 0);
exports.BillingApiOrderPayResponseDto = BillingApiOrderPayResponseDto;
